import { useTranslate } from "@similarweb/i18n-provider";

import APIsWebhooksContainer from "app/pages/sales-intelligence/modules/manage-integrations/containers/APIsWebhooksContainer";
import ManagementPageHeader from "app/pages/sales-intelligence/pages/management/components/ManagementPageHeader/ManagementPageHeader";

import withSecondaryBarSet from "../../../../hoc/withSecondaryBarSet";
import ManagementPageWrapper from "../../components/ManagementPageWrapper/ManagementPageWrapper";
import { MANAGEMENT_APIS_AND_WEBHOOKS } from "../../translations/managementKeys";

const APIsAndWebhooksPageContainer = () => {
    const { translate } = useTranslate();

    return (
        <ManagementPageWrapper>
            <ManagementPageHeader text={translate(MANAGEMENT_APIS_AND_WEBHOOKS)} />

            <APIsWebhooksContainer />
        </ManagementPageWrapper>
    );
};

export default withSecondaryBarSet("SalesIntelligenceLists")(APIsAndWebhooksPageContainer);
